<template>
  <div class="tabs pa-5">
    <v-tabs
      v-model="activeTab"
      hide-slider
      height="0"
    >
      <v-tab
        v-for="tab of tabs"
        :key="tab.id"
        :to="tab.route"
        disabled
        exact
      >
        <v-icon small class="mr-1">{{ tab.icon }}</v-icon>
        {{ tab.name }}
      </v-tab>
      <v-tab-item
        v-for="tab of tabs"
        :key="tab.id"
        :value="tab.route"
      >
        <router-view></router-view>
      </v-tab-item>
    </v-tabs>
    <v-btn
      v-for="btn of tabs"
      :key="btn.id"
      :to="btn.route"
      :color="btn.bgcolor"
    >
      <v-icon small class="mr-1">{{ btn.icon }}</v-icon>
      {{ btn.name }}
    </v-btn>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        activeTab: `/utabs`,
        tabs: [
          { id: '1', name: 'Users', route: `/utabs/user`, icon: 'mdi-account-tie', bgcolor: 'red lighten-5' },
          { id: '2', name: 'Payments', route: `/utabs/payment`, icon: 'mdi-cash-multiple', bgcolor: 'green lighten-5' }
        ],
      };
    }
  };
</script>
